import React,{useRef,useEffect} from 'react';  
 
  import GifGrid from '../components/GifGrid'
  import CheckItOut from '../components/CheckItOut'
  import {Divider 
  } from 'semantic-ui-react'
 
  function Interactive(props){ 

      const header = <div><i>Cascade Tactics</i> is designed to be a highly interactive tactical RPG.</div>
      return    <div><GifGrid
        width={props.width}
        height={props.height}
        headerText ={header}
        gifData={[
          {headerText:"Stop opponent's action by dealing damage", gif:"Cancel1.gif"},
          {headerText:"Interact with objects in the scene", gif:"Scorpion1.gif"},
          {headerText:"Push allies into safety or enemies into harm", gif:"Push1.gif"},
          {headerText:"Change opponent's targets", gif:"Retarget1.gif"},
          {headerText:"Interact with terrain to access new areas or isolate an opponent", gif:"MoldEarth1.gif"},
          {headerText:"Use Ice Prison to freeze an enemy or target an ally to protect him", gif:"IceBreak1.gif"},

        ]}
      > 
      </GifGrid> 
      <Divider></Divider>
      <CheckItOut hiddenButton='interactive'></CheckItOut>
      </div>
  }
  
export default Interactive;